/**
 * Vuex
 *
 * @library
 *
 * https://vuex.vuejs.org/en/
 */

// Lib imports
import Vue from 'vue'
import Vuex from 'vuex'

// Store functionality
import modules from './modules'

Vue.use(Vuex)

// Create a new store
const store = new Vuex.Store({
  state: {
    sidenav: true
  },
  getters: {
    sidenav: state => state.sidenav
  },
  mutations: {
    toggleSideNav: (state, value) => {
      if (typeof value === 'boolean') {
        state.sidenav = value;
        return;
      }
      state.sidenav = !state.sidenav;
    }
  },
  actions: {
    toggleSideNav({commit}, value) {
      commit('toggleSideNav', value)
    }
  },
  modules
})

export default store
